export default "__VITE_ASSET__06388bcc__"